class SimplePubSub { // eslint-disable-line no-unused-vars, no-redeclare
    Callbacks = [];

    subscribe(name, callback) {
        this.Callbacks.push({ name, callback });
    }

    publish(...argsList) {
        this.Callbacks.forEach(({ name, callback }) => {
            console.debug(`Running "${name}"`);
            console.debug(callback);
            callback(...argsList);
        });
    }

    unsubscribe(nameOrCallback) {
        var idx = -1;
        if ((typeof nameOrCallback === "string")) {
            idx = this.Callbacks.findIndex(c => c.name === nameOrCallback);
        }
        else if ((typeof nameOrCallback === "function")) {
            idx = this.Callbacks.findIndex(c => c.callback === nameOrCallback);
        }
        if (idx > -1) {
            this.Callbacks.splice(idx, 1);
        }
    }
}